import { createGlobalStyle, css } from "styled-components";

import cursorAuto from "./assets/cursors/cursor_auto.png";
import cursorPointer from "./assets/cursors/cursor_pointer.png";

const styles = css`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: "Londrina Solid", Impact, Haettenschweiler, "Arial Narrow Bold",
      sans-serif;
    background-color: #000000;
    margin: 0;
    cursor: url(${cursorAuto}), auto;
  }

  button {
    font-family: inherit;
    cursor: url(${cursorPointer}) 28 0, pointer;
  }

  a {
    cursor: url(${cursorPointer}) 28 0, pointer;
  }
`;

const GlobalStyle = createGlobalStyle`
  ${styles}
`;

export default GlobalStyle;
